import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Agar URL mein #id hai, toh us element ko dhoondo
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        // Thoda delay taaki component render ho jaye
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    } else {
      // Agar koi hash nahi hai, toh page top par reset karo
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
